// extracted by mini-css-extract-plugin
export default {"addToCartControl":"Q1-z","giftCard":"R1-z","btnContainer":"S1-z","cartButton":"T1-z","disabled":"U1-z"};